import React from "react";
import { connect } from "react-redux";
import HeaderTitle from "header/components/title";

const mapStateToProps = () => {
  return {
    title: "Email Unsubscribe",
  };
};

export default connect(mapStateToProps)(HeaderTitle);
